import { render } from "./Packages.vue?vue&type=template&id=bc092bd6"
import script from "./Packages.vue?vue&type=script&lang=js"
export * from "./Packages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__